import { ButtonLinkProps, Footer } from '@vk-cloud-solutions/marketing-ui';
import classNames from 'classnames';

import { ImageProps } from '~components/Image/Image.types';
import styles from '~components/Page/Page.module.scss';
import { env } from '~constants/env';
import GiftIcon from '~public/static/images/icons/gift_outline_28.svg';
import ChatIcon from '~public/static/images/icons/message_outline_28.svg';

import { FooterCloudProps } from './FooterCloud.types';

export function FooterCloud({
  logo,
  chatLink,
  bonusLink,
  columns,
  bottomSection,
}: FooterCloudProps) {
  const currentYear = new Date().getFullYear();
  const copyright = `© VK Cloud, ${currentYear}. Все права защищены.`;
  const renderAdditionalButtons = (
    chatLink?: ButtonLinkProps,
    bonusLink?: ButtonLinkProps,
  ) => (
    <div className={styles.buttons}>
      {bonusLink?.href && (
        <a
          href={bonusLink.href}
          target={bonusLink.target}
          className={classNames(styles.button, styles.bonusButton)}
        >
          <GiftIcon className={styles.buttonIcon} />
          {bonusLink.text}
        </a>
      )}
      {chatLink?.href && (
        <a
          href={chatLink.href}
          target={chatLink.target}
          className={classNames(styles.button, styles.chatButton)}
        >
          <ChatIcon className={styles.buttonIcon} />
          {chatLink.text}
        </a>
      )}
    </div>
  );

  return (
    <Footer
      logo={logo as ImageProps}
      additionalButtons={
        chatLink || bonusLink
          ? renderAdditionalButtons(chatLink, bonusLink)
          : undefined
      }
      columns={columns}
      bottomSection={{
        ...bottomSection,
        copyright,
        endorsementLogo: {
          src: `${env.static}/images/icons/logos/VK_tech_logo_dark.svg`,
        },
      }}
    />
  );
}
